import React from 'react';
import { FeedsDataItem } from '../feeds_list_types';

interface AdditionalPanelsProps {
    feedItem: FeedsDataItem;
}

const AdditionalPanels = ({ feedItem }: AdditionalPanelsProps): JSX.Element | null => {
    const hasMultipleEntities = feedItem.CoveredEntity?.length > 1;
    const hasMultiplePharmacies = feedItem.Pharmacy?.length > 1;
    const hasDuplicateInfo = !!feedItem.DuplicateOf;

    // Don't render if no additional panels are needed
    if (!hasMultipleEntities && !hasMultiplePharmacies && !hasDuplicateInfo) {
        return null;
    }

    return (
        <>
            {/* Entity Lists (when multiple) */}
            {(hasMultipleEntities || hasMultiplePharmacies) && (
                <section className="entity-lists-section panel-spacing">
                    <h3>Entity Details</h3>

                    {hasMultipleEntities && (
                        <div className="entity-list">
                            <h4>Facility List ({feedItem.CoveredEntity.length})</h4>
                            <div className="entity-items">
                                {feedItem.CoveredEntity.map((entity, index) => (
                                    <div
                                        key={index}
                                        className="entity-item"
                                    >
                                        {entity}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {hasMultiplePharmacies && (
                        <div className="entity-list">
                            <h4>Pharmacy List ({feedItem.Pharmacy.length})</h4>
                            <div className="entity-items">
                                {feedItem.Pharmacy.map((pharmacy, index) => (
                                    <div
                                        key={index}
                                        className="entity-item"
                                    >
                                        {pharmacy}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </section>
            )}
        </>
    );
};

export default React.memo(AdditionalPanels);
